type Coordinate = {
  lat: number;
  lng: number;
};

// Fonction pour calculer la distance entre deux points GPS en utilisant la formule de Haversine
function haversineDistance(coord1: Coordinate, coord2: Coordinate): number {
  const R = 6371e3; // Rayon de la Terre en mètres
  const φ1 = (coord1.lat * Math.PI) / 180; // Conversion en radians
  const φ2 = (coord2.lat * Math.PI) / 180;
  const Δφ = ((coord2.lat - coord1.lat) * Math.PI) / 180;
  const Δλ = ((coord2.lng - coord1.lng) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance en mètres
}

// Fonction pour trouver la plus longue distance entre deux points d'une liste
export function findMaxDistance(coords: Coordinate[]): number {
  let maxDistance = 0;

  for (let i = 0; i < coords.length; i++) {
    for (let j = i + 1; j < coords.length; j++) {
      const distance = haversineDistance(coords[i], coords[j]);
      if (distance > maxDistance) {
        maxDistance = distance;
      }
    }
  }

  return maxDistance;
}
